<template>
  <div class="mr-header">
    <div class="m-head">
        <i class="list-icon" @click="openList"></i>
        <ul class="head-list-box" v-show="showList">
          <li class="list-item" :class="{actimg: activeIndex == index}" v-for="(item, index) in listData" :key="index" @click="slideChangeFn(index)">
            <a class="heeh" :href="'#msection'+(index+1)" v-if="index < 6"></a>
            <img class="list-word" v-if="activeIndex == index" v-lazy="require(`@/assets/images/mobile/1/${item}_sel.png`)" alt="">
            <img class="list-word" v-else v-lazy="require(`@/assets/images/mobile/1/${item}.png`)" alt="">
          </li>
          <li class="list-btn-item">
            <img
              @click="jump(item.url, index)"
              class="list-btn"
              v-for="(item, index) in _myData.headIconList"
              :key="index"
              :src="item.icon"
              alt=""
            />
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      listData: ['home', 'news', 'story', 'chact', 'system', 'faq'],  //列表数据
      activeIndex: 0,   // 当前轮播索引
      showList: false,  // 列表展示显隐
    };
  },
  computed: {
    ...mapState(["_myData"]),
    sectionHeight () {
      return 1080 - window.innerHeight
    }
  },
  created () {
    // if(this.$route.name == 'protocol') {
    //   this.activeIndex = -1;
    // }

    // if (this.$route.name == 'news' || this.$route.name == 'detail') {
    //   this.activeIndex = 1
    // }

    // if (this.$route.name == 'detail') {
    //   this.activeIndex = 1
    //   if (this.$route.query.id == 'faq') {
    //     this.activeIndex = 5
    //   }
    // }
  },
  mounted() {
  },
  methods: {

    // 关闭列表
    closeListFn() {
      this.showList = false;
    },

    // 打开列表
    openList() {
      this.showList = !this.showList;
    },

    // 点击滚动到相应slide
    slideChangeFn(index) {
      if (index == 5 && !this._myData.showFaq) {
        layer.open({
          content: 'まだ公開されていません。しばらくお待ちください。',
          time: 2,
          skin: 'msg'
        })
        return false
      }

      this.activeIndex = index;
      this.$emit('slideto', index);
      this.showList = false;
    },

    // 设置当前索引
    setActiveIndex(index) {
      this.activeIndex = index;
    },

    jump(url, index) {
      window.open(url, "_self");
    },


  },
};
</script>

<style lang="scss" scope>
.mr-header {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  text-align: center;
  @include wh(0, 120);
  .m-head {
    display: inline-block;
    @include wh(750, 120);
    position: relative;
    z-index: 100;
    @include mbg('head.png');
    .list-icon {
      @include rt(70, 40);
      @include wh(52, 41);
      @include mbg('1/list_icon.png');
    }
    .head-list-box {
      @include rt(0, 120);
      @include wh(261, 521);
      @include mbg('1/list_back.png');
      .list-item {
        @include wh(261, 74);
        position: relative;
        .heeh {
          display: block;
          @include wh(261, 74);
          @include lt(0, 0);
          outline: none;
        }
        .list-word {
          display: block;
          @include wh(261, 73);
        }
      }
      .list-btn-item {
        @include wh(261, 74);
        display: flex;
        justify-content: space-around;
        align-items: center;
        align-content: center;
        .list-btn {
          display: inline-block;
          @include wh(47, 47);
        }
      }
      .actimg {
        @include mbg('1/list_seled.png');
      }
    }
  }
}
</style>
